// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Xeb","rounded":"az_Yeb","outlined":"az_Zeb","elevation0":"az__eb","elevation1":"az_afb","elevation2":"az_bfb","elevation6":"az_cfb","elevation4":"az_dfb"};